import { render, staticRenderFns } from "./LiveFoot.vue?vue&type=template&id=6c0edb7e&scoped=true&"
import script from "./LiveFoot.vue?vue&type=script&lang=js&"
export * from "./LiveFoot.vue?vue&type=script&lang=js&"
import style0 from "./LiveFoot.vue?vue&type=style&index=0&id=6c0edb7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0edb7e",
  null
  
)

export default component.exports